import { render } from "./MyCouponsIndexOfPast.vue?vue&type=template&id=5815fbba"
import script from "./MyCouponsIndexOfPast.vue?vue&type=script&lang=js"
export * from "./MyCouponsIndexOfPast.vue?vue&type=script&lang=js"
script.render = render

export default script